import { render, staticRenderFns } from "./color-palette.vue?vue&type=template&id=5bc92b82"
import script from "./color-palette.vue?vue&type=script&lang=js"
export * from "./color-palette.vue?vue&type=script&lang=js"
import style0 from "./color-palette.vue?vue&type=style&index=0&id=5bc92b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports